export default __webpack_public_path__ + "static/images/5074e980d081ba152814bf720340ea61.svg";